import React, { useEffect, useState } from 'react'
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { Container, Row, Col } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import Information from '../../../../Shared/Card/Information';
import { GetAppInformationContent } from '../../../../Shared/InformationContent/PeInformation';
import publicApplicationService from '../../../../../services/Public/Application/PE/peApplication.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import Swal from 'sweetalert2';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import Acknowledgement from '../../../../Shared/Card/Acknowledgement';
import peApplicationService from '../../../../../services/Internal/Application/PE/peApplication.service';
import applicationService from '../../../../../services/Internal/Application/application.service';
import FormEntityInformation from '../../../Shared/FormEntityInformation';

function AcknowledgementPage() {
    const [hasLoaded, setHasLoaded] = useState(false)
    const push = useNavigate();
    const { StringType } = Schema.Types;
    const appId = useSelector(x => x.currentApplicationId);
    const appTypeId = useSelector(x => x.currentApplicationTypeId);
    const appType = appTypeId == 3 ? "By Comity" : appTypeId == 4 ? "By Exam" : "";
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 8;
    const [formModel, setFormModel] = useState({})
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Engineer Application " + appType,
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Acknowledgement"
        }
    );
    useEffect(() => {
        publicApplicationService.peGetSection(appId, sectionId).then((response) => {
            setFormModel(response.data);
            setIsComplete(response.data.staffReviewComplete)
            applicationService.getIndividualApplication(appId).then((appData) => {
                setIsUserEditable(appData.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: appData.data?.credential?.formattedLicenseNumber,
                            applicationDate: appData.data?.dateSubmitted
                        })
                    setHasLoaded(true);
                });
            });
        })
    }, [])
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.')
    });

    const formSubmit = (validation, event) => {
        publicApplicationService.pePostSection(appId, sectionId, formModel.electronicSignature).then((response) => {
            if (response.data.id) {
                peApplicationService.peMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
                    if (response.data) {
                        nextSectionNavigation();
                    }
                });
            }
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
    }
    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Row>
                    <Col>
                        <Information content={GetAppInformationContent("acknowledgement")} className="mb-3" />
                    </Col>
                </Row>
                <br />
                {hasLoaded ?
                    <Form readOnly={!isUserEditable} model={model} fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                        <Row>
                            <Col>
                                <Acknowledgement appType="application" />
                            </Col>
                        </Row>
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={1} sectionId={formModel.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isReadOnly={!isUserEditable}
                            nextSectionCallback={nextSectionNavigation}
                            isUserEditable={isUserEditable}
                            showSectionComplete={true}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete} backToSectionLink="/internal/peapp/sections" />
                    </Form> : <LoadingSpinner />
                }
            </Container>
        </div>
    );
}
export default AcknowledgementPage